








































import { Component, Mixins, Prop } from 'vue-property-decorator'
import BaseComponent from '@/tcw/components/BaseComponent'
import { ApiGeneralObjectArrayPayload, ApiGeneralSinglePayload, CodeLabel } from '@/tcw/api/types'

import 'ag-grid-community/dist/styles/ag-grid.css'
import 'ag-grid-community/dist/styles/ag-theme-blue.css'
import { AgGridVue } from 'ag-grid-vue'
import { ColDef, GridOptions, ValueFormatterParams } from 'ag-grid-community'
import { KEY_CLASS_YOUBI_TYPE } from '@/tcw/constant/KeyClass'

@Component({
  components: { AgGridVue }
})
export default class KeisanDrawer extends Mixins(BaseComponent) {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  @Prop({ default: () => {} })
  protected keisan!: ApiGeneralSinglePayload

  protected youbiLabelList: CodeLabel[] | null = null
  protected uchiwakeColumnDefs: ColDef[] = [
    {
      field: 'heijitsu.jitsudou',
      headerName: '平日-実働',
      valueFormatter: this.JikanFormatter
    },
    {
      field: 'heijitsu.jikangai',
      headerName: '平日-時間外',
      valueFormatter: this.JikanFormatter
    },
    {
      field: 'heijitsu.shinya',
      headerName: '平日-深夜',
      valueFormatter: this.JikanFormatter
    },
    {
      field: 'houteigaiKyujitsu.jitsudou',
      headerName: '法定外-実働',
      valueFormatter: this.JikanFormatter
    },
    {
      field: 'houteigaiKyujitsu.jikangai',
      headerName: '法定外-時間外',
      valueFormatter: this.JikanFormatter
    },
    {
      field: 'houteigaiKyujitsu.shinya',
      headerName: '法定外-深夜',
      valueFormatter: this.JikanFormatter
    },
    {
      field: 'houteiKyujitsu.jitsudou',
      headerName: '法定-実働',
      valueFormatter: this.JikanFormatter
    },
    {
      field: 'houteiKyujitsu.jikangai',
      headerName: '法定-時間外',
      valueFormatter: this.JikanFormatter
    },
    {
      field: 'houteiKyujitsu.shinya',
      headerName: '法定-深夜',
      valueFormatter: this.JikanFormatter
    }
  ]

  protected JikanFormatter(params: ValueFormatterParams): string {
    return this.du.outputHun(params.value, false)
  }
  protected JikanFormatterDivide60(params: ValueFormatterParams): string {
    const value = Number(params.value)
    if (Number.isNaN(value)) {
      return ''
    }
    return this.du.outputHun(value / 60, false)
  }
  protected getYoubiName(params: ValueFormatterParams): string {
    const codeLabel = this.youbiLabelList?.find(
      (v: CodeLabel) => String(v.code) === String(params.value)
    )
    return codeLabel ? codeLabel.label : ''
  }

  protected kakushuColumnDefs: ColDef[] = [
    {
      field: 'shuBango',
      headerName: '週番号'
    },
    {
      field: 'kikanKaishi',
      headerName: 'From'
    },
    {
      field: 'kikanShuryo',
      headerName: 'To'
    },
    {
      field: 'houteiRoudouJikan',
      headerName: '法定労働時間',
      valueFormatter: this.JikanFormatter
    },
    {
      field: 'houteiNaiRoudouJikan',
      headerName: '法定内労働時間',
      valueFormatter: this.JikanFormatter
    },
    {
      field: 'heijitsu.jitsudou',
      headerName: '平日-実働',
      valueFormatter: this.JikanFormatter
    },
    {
      field: 'heijitsu.jikangai',
      headerName: '平日-時間外',
      valueFormatter: this.JikanFormatter
    },
    {
      field: 'heijitsu.shinya',
      headerName: '平日-深夜',
      valueFormatter: this.JikanFormatter
    },
    {
      field: 'heijitsu.hounaiJikangai',
      headerName: '平日-法内残業',
      valueFormatter: this.JikanFormatter
    },
    {
      field: 'kyujitsu.jitsudou',
      headerName: '休日-実働',
      valueFormatter: this.JikanFormatter
    },
    {
      field: 'kyujitsu.jikangai',
      headerName: '休日-時間外',
      valueFormatter: this.JikanFormatter
    },
    {
      field: 'kyujitsu.shinya',
      headerName: '休日-深夜',
      valueFormatter: this.JikanFormatter
    },
    {
      field: 'kyujitsu.hounaiJikangai',
      headerName: '休日-法内残業',
      valueFormatter: this.JikanFormatter
    },
    {
      field: 'zentai.jitsudou',
      headerName: '全体-実働',
      valueFormatter: this.JikanFormatter
    },
    {
      field: 'zentai.jikangai',
      headerName: '全体-時間外',
      valueFormatter: this.JikanFormatter
    },
    {
      field: 'zentai.shinya',
      headerName: '全体-深夜',
      valueFormatter: this.JikanFormatter
    },
    {
      field: 'zentai.hounaiJikangai',
      headerName: '全体-法内残業',
      valueFormatter: this.JikanFormatter
    }
  ]
  protected kyujitsuColumnDefs: ColDef[] = [
    {
      field: 'hizuke',
      headerName: '日付'
    },
    {
      field: 'youbiCode',
      headerName: '曜日',
      valueFormatter: this.getYoubiName
    },
    {
      field: 'jikan.jitsudou',
      headerName: '実働',
      valueFormatter: this.JikanFormatter
    },
    {
      field: 'jikan.jikangai',
      headerName: '時間外',
      valueFormatter: this.JikanFormatter
    },
    {
      field: 'jikan.shinya',
      headerName: '深夜',
      valueFormatter: this.JikanFormatter
    },
    {
      field: 'houteiKyujitsu',
      headerName: '法定休日',
      valueFormatter: (params: ValueFormatterParams): string => (params.value === true ? '○' : '-')
    }
  ]

  protected get gridOptions(): GridOptions {
    return {
      rowSelection: 'single',
      defaultColDef: {
        resizable: true,
        cellStyle: {
          'font-family': '"M PLUS Rounded 1c", sans-serif',
          'font-size': '12px'
        }
      },
      onGridReady: params => {
        this.initColumnsSize(params)

        const goukeiGyou = this.kakushuJikanGoukei
        if (goukeiGyou) {
          goukeiGyou.shuBango = '合計'
        }
        params.api.setPinnedBottomRowData([goukeiGyou])
      }
    }
  }

  /**
   * 表のカラムサイズ初期化
   */
  private initColumnsSize(params: any) {
    if (this.isMobile) {
      // モバイル版は横スクロール出てもいいからカラム内容でサイズ調整
      params.columnApi.autoSizeAllColumns()
    } else {
      // デスクトップ版は横スクロール出ないように画面サイズで調整
      params.api.sizeColumnsToFit()
    }
  }
  protected get kakushuData(): ApiGeneralObjectArrayPayload {
    if (!this.keisan || !Array.isArray(this.keisan.kakushuKinmuJikanList)) {
      return []
    }

    const kakushuKinmuJikanList = this.keisan.kakushuKinmuJikanList as ApiGeneralObjectArrayPayload
    return kakushuKinmuJikanList.sort((a, b) => {
      const kijunKaishi = a.kikanKaishi as string
      const hikakuKaishi = b.kikanKaishi as string
      return this.du.isBefore(kijunKaishi, hikakuKaishi) ? -1 : 1
    })
  }
  protected get kyujitsuData(): ApiGeneralObjectArrayPayload {
    return this.keisan.kyujitsuShukkinList as ApiGeneralObjectArrayPayload
  }

  protected get uchiwakeData(): ApiGeneralObjectArrayPayload {
    return this.keisan && this.keisan.kinmuJikanUchiwake
      ? [this.keisan.kinmuJikanUchiwake as ApiGeneralSinglePayload]
      : []
  }
  protected get kakushuJikanGoukei(): ApiGeneralSinglePayload {
    return this.keisan && this.keisan.kakushuJikanGoukei
      ? (this.keisan.kakushuJikanGoukei as ApiGeneralSinglePayload)
      : {}
  }

  protected async created(): Promise<void> {
    await this.beforeProc()
  }
  protected async beforeProc(): Promise<void> {
    this.youbiLabelList = await this.codeLabel.getCodeLabelList(KEY_CLASS_YOUBI_TYPE)
  }
}
